module.exports = __webpack_public_path__ + "static/media/400074_01.2bc33163.png";